export default __webpack_public_path__ + "static/media/chatton15.49ca54ea.jpg";